import { SiteHeader } from "@/components/landing/SiteHeader";
import { SiteFooter } from "@/components/landing/SiteFooter";
import type { ReactNode } from "react";

export function BlogShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background text-foreground paper-grain">
      <SiteHeader />
      {children}
      <SiteFooter />
    </div>
  );
}
